import styled from 'styled-components';
import { colors } from '../../theme/color';
import { Path } from '../../routes/components/path';
import { NavigationItem } from './NavigationItem';
import { bottomNavigationHeightString, useIsBottomNavigationDisabled } from './helpers';
import { HomeOutlined } from '../../icons/BottomNavigation/HomeOutlined';
import { HomeFilled } from '../../icons/BottomNavigation/HomeFilled';
import { LoyaltyOutlined } from '../../icons/BottomNavigation/LoyaltyOutlined';
import { LoyaltyFilled } from '../../icons/BottomNavigation/LoyaltyFilled';
import { PizzaOutlined } from '../../icons/BottomNavigation/PizzaOutlined';
import { PizzaFilled } from '../../icons/BottomNavigation/PizzaFilled';
import { AgainOutlined } from '../../icons/BottomNavigation/AgainOutlined';
import { AgainFilled } from '../../icons/BottomNavigation/AgainFilled';
import { MoreOutlined } from '../../icons/BottomNavigation/MoreOutlined';
import { MoreFilled } from '../../icons/BottomNavigation/MoreFilled';

export const BottomNavigation: React.FC = () => {
  const isBottomNavigationDisabled = useIsBottomNavigationDisabled();

  if (isBottomNavigationDisabled) {
    return null;
  }

  return (
    <Container>
      <NavigationContainer aria-label="Päänavigaatio">
        <NavigationItem
          icon={<HomeOutlined aria-hidden="true" />}
          iconActive={<HomeFilled aria-hidden="true" />}
          label="Koti"
          path={Path.Home}
        />
        <NavigationItem
          icon={<LoyaltyOutlined aria-hidden="true" />}
          iconActive={<LoyaltyFilled aria-hidden="true" />}
          label="Edut"
          path={Path.LoyaltyBenefits}
        />
        <NavigationItem
          icon={<PizzaOutlined aria-hidden="true" />}
          iconActive={<PizzaFilled aria-hidden="true" />}
          label="Tilaa"
          path={Path.Menu}
        />
        <NavigationItem
          icon={<AgainOutlined aria-hidden="true" />}
          iconActive={<AgainFilled aria-hidden="true" />}
          label="Aiemmat"
          path={Path.AppOrderAgain}
        />
        <NavigationItem
          icon={<MoreOutlined aria-hidden="true" />}
          iconActive={<MoreFilled aria-hidden="true" />}
          label="Lisää"
          path={Path.AppMore}
        />
      </NavigationContainer>
    </Container>
  );
};

const NavigationContainer = styled.nav`
  padding-bottom: env(safe-area-inset-bottom);
  height: ${bottomNavigationHeightString};
  padding-left: 8px;
  padding-right: 8px;
  background-color: ${colors.white};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  touch-action: none;
  border-top: 1px solid ${colors.gray10};
`;

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
`;
